import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { ResizableBox } from 'react-resizable'

class ResizableDiv extends Component {
  static propTypes = {
    children: PropTypes.object,
  }

  render() {
    const { children, ...props } = this.props

    return <ResizableBox {...props}>{children}</ResizableBox>
  }
}

export default ResizableDiv
